import axios from './BaseService';

const FEEDBACK_URL = `${
    process.env.REACT_APP_API_URL || window._env_?.REACT_APP_API_URL
}/feedback`;

export async function sendFeedback(payload) {
    const response = await axios.post(`${FEEDBACK_URL}/`, payload);
    return response.data;
}
